export default __webpack_public_path__ + "static/media/fusao1.1af3c26e.png";